import { format } from "../libs/date.format";

const datesMixins = {
    data() {
        return {
            fullWeekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        };
    },
    methods: {
        getWeekdayFromDate(date) {
            return this.fullWeekdays[date.getDay()];
        },

        formattedStartEndTime(start, end) {
            return {
                startDate: `${this.fullWeekdays[start.getDay()]} ${format(start, "dS mmmm yyyy")}`,
                endDate: `${this.fullWeekdays[end.getDay()]} ${format(end, "dS mmmm yyyy")}`,
            };
        },
    },
};

export default datesMixins;
